export enum InvitationLogEntryType {
  InvitationCreated = 'INVITATION_CREATED',
  InvitationSent = 'INVITATION_SENT',
  InvitationArchived = 'INVITATION_ARCHIVED',
  ResponsiblePersonChanged = 'RESPONSIBLE_PERSON_CHANGED',
  DetailsConfirmed = 'DETAILS_CONFIRMED',
  PersonEntryOverride = 'PERSON_ENTRY_OVERRIDE',
  SupplierRiskConfirmed = 'SUPPLIER_RISK_CONFIRMED',
  RisksConfirmed = 'RISKS_CONFIRMED',
  PersonAdded = 'PERSON_ADDED',
  PersonRemoved = 'PERSON_REMOVED',
  CertificateAdded = 'CERTIFICATE_ADDED',
  CertificateConfirmed = 'CERTIFICATE_CONFIRMED',
  PinViewed = 'PIN_VIEWED',
  ActivityDocumentUploaded = 'ACTIVITY_DOCUMENT_UPLOADED',
  ActivityDocumentApproved = 'ACTIVITY_DOCUMENT_APPROVED',
  ActivityDocumentRemoved = 'ACTIVITY_DOCUMENT_REMOVED',
  EmployeeChanged = 'EMPLOYEE_CHANGED',
  EntryRequestCreated = 'ENTRY_REQUEST_CREATED',
  EntryRequestApproved = 'ENTRY_REQUEST_APPROVED',
  EntryRequestRejected = 'ENTRY_REQUEST_REJECTED',
  EntryRequestChanged = 'ENTRY_REQUEST_CHANGED',
  EntryRequestDeleted = 'ENTRY_REQUEST_DELETED',
  ArchivedByCronjob = 'ARCHIVED_BY_CRONJOB',
  ActivityAdded = 'ACTIVITY_ADDED',
  ActivityRemoved = 'ACTIVITY_REMOVED',
  WorkplaceAdded = 'WORKPLACE_ADDED',
  WorkplaceRemoved = 'WORKPLACE_REMOVED',
}
